const CopyIcon = ({ width = 15, height = 17 }) => (
  <svg
    width={ width }
    height={ height }
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.542 3.75V1.375a.792.792 0 0 1 .791-.792h9.5a.792.792 0 0 1 .792.792v11.083a.791.791 0 0 1-.792.792h-2.375v2.375a.794.794 0 0 1-.797.792H1.172a.793.793 0 0 1-.797-.792L.377 4.542c0-.437.357-.792.798-.792h2.367Zm1.583 0h6.333v7.917h1.584v-9.5H5.125V3.75Z"
      fill="#DC3CAA"
    />
  </svg>
);

export default CopyIcon;
